<template>
  <div class="l-AreaSelect">
      <el-select :disabled="disable" v-model="provinceId" placeholder="选择省份" size="small"  :clearable="clearable">
        <el-option v-for="item in province" :key="item.areaid" :label="item.areaname" :value="item.areaid"></el-option>
      </el-select>
    <el-select :disabled="disable" v-model="cityId" placeholder="选择城市" size="small"  :clearable="clearable">
      <el-option v-for="item in city" :key="item.areaid" :label="item.areaname" :value="item.areaid"></el-option>
    </el-select>
    <el-select :disabled="disable" v-model="areaId"  placeholder="选择地区" size="small"  :clearable="clearable">
      <el-option v-for="item in area" :key="item.areaid" :label="item.areaname" :value="item.areaid"></el-option>
    </el-select>
  </div>
</template>

<script>
  // import {mapGetters} from 'vuex'
  import request from '@/utils/request'
  export default {
    props: ['_provinceId', '_cityId', '_areaId', 'clearable', 'disable', 'grade'],
    data () {
      return {
        province: [],
        provinceId: null,
        provinceName: '',
        cityId: null,
        cityName: '',
        areaId: null,
        areaName: '',
        city: [],
        area: [],
        first: true
      }
    },
    watch: {
      provinceId () {
        this.changeP()
      },
      cityId () {
        this.changeC()
      },
      areaId (val) {
        if (val) {
          let a = this.area.find(a => {
            return a.areaid === this.areaId
          })
          this.areaName = a.areaname
        } else {
          this.areaName = ''
        }
      },
      str () {
        this.over()
      }
    },
    mounted () {
      request ({
        url: 'kfgl/area/getAreaTree',
        method: 'get',
        params: {}
      }).then(res => {
        this.province = res.list
        this.provinceId = this._provinceId
      })
    },
    methods: {
      changeP () {
        let a = this.province.find(a => {
          return a.areaid === this.provinceId
        })
        if (a && a.children) {
          this.provinceName = a.areaname
          this.city = a.children
          this.cityId = this.first ? this._cityId : null
          this.areaId = null
          this.area = []
        }
      },
      changeC () {
        let a = this.city.find(a => {
          return a.areaid === this.cityId
        })
        if (a && a.children) {
          this.cityName = a.areaname
          this.area = a.children
          this.areaId = this.first ? this._areaId : null
        }
        this.first = false
      },
      over () {
        this.$emit('changed', {
          provinceId: this.provinceId,
          provinceName: this.provinceName,
          cityId: this.cityId,
          cityName: this.cityName,
          areaId: this.areaId,
          areaName: this.areaName
        })
      }
    },
    computed: {
      // ...mapGetters(['province']),
      str () {
        return this.provinceId + '_' + this.cityId + '_' + this.areaId
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '../../styles/variables.scss';
  .l-AreaSelect {
    display: flex;
  }
</style>
